import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';

export default function CopyIdElement(props) {
    const {
        isShow,
        copyId,
        messageShareLink,
        title,
        setChatPostShowFlagMsgCopyMsgId,
        isCopyImgLink
    } = props;

    if (!isShow) return null;

    const onClickCopy = () => {
        navigator.clipboard.writeText(messageShareLink);
        if (!setChatPostShowFlagMsgCopyMsgId) return;
        setChatPostShowFlagMsgCopyMsgId(prev => {
            return {
                ...prev,
                [copyId]: true
            };
        });

        setTimeout(() => {
            setChatPostShowFlagMsgCopyMsgId(prev => {
                return {
                    ...prev,
                    [copyId]: false
                };
            });
        }, 3000);
    };

    return (
        <Tooltip title={title ? title : ''} arrow placement="top-center">
            <IconButton
                className="copy-id-element-content"
                onClick={() => onClickCopy()}
                disabled={false}
            >
                {isCopyImgLink ? (
                    <div
                        style={{
                            height: 17,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <svg
                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                            focusable="false"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                        >
                            <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"></path>
                        </svg>
                    </div>
                ) : (
                    <div
                        style={{
                            height: 17,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <img src="/assets/image/icon-link-share.svg" alt="" />
                    </div>
                )}
            </IconButton>
        </Tooltip>
    );
}
